import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import Button02 from "../button/Button02";
import DataAbout from "../../assets/fake-data/data-about";

function About2() {
  const { t } = useTranslation();
  const data = DataAbout();
   const [showAll, setShowAll] = useState(false);
  
    const reviews = [
      {
        id: 1,
        role: "Buyer",
        name: "Alex Doren",
        text: "I bought 27 EA FC coins, the process was smooth and quick. Highly recommend for anyone looking to buy!",
        stars: 5,
      },
      {
        id: 2,
        role: "Seller",
        name: "Will Kady",
        text: "Sold 27 EA FC coins. The team was very responsive and the transaction was seamless.",
        stars: 5,
      },
      {
        id: 3,
        role: "Buyer",
        name: "Bob Zand",
        text: "I purchased 27 EA FC coins, the exchange was completed without any issues. Great experience!",
        stars: 5,
      },
      {
        id: 4,
        role: "Seller",
        name: "Jacob Oned",
        text: "Sold 27 EA FC coins, everything went well. Will definitely come back for future exchanges!",
        stars: 5,
      },
      {
        id: 5,
        role: "Buyer",
        name: "Chris Nolan",
        text: "Great service, fast and reliable. Highly recommended!",
        stars: 5,
      },
      {
        id: 6,
        role: "Seller",
        name: "David Smith",
        text: "Selling was easy and quick. Thanks!",
        stars: 5,
      },
      {
        id: 7,
        role: "Buyer",
        name: "Emma Watson",
        text: "Very smooth process, would buy again!",
        stars: 5,
      },
      {
        id: 8,
        role: "Seller",
        name: "John Doe",
        text: "No issues at all, great support.",
        stars: 5,
      },
      {
        id: 9,
        role: "Buyer",
        name: "Sara Connor",
        text: "Super fast transaction, highly recommended.",
        stars: 5,
      },
      {
        id: 10,
        role: "Seller",
        name: "Luke Bryan",
        text: "Excellent service, fast payment.",
        stars: 5,
      },
      {
        id: 11,
        role: "Buyer",
        name: "Mike Tyson",
        text: "I was skeptical, but everything went perfectly!",
        stars: 5,
      },
      {
        id: 12,
        role: "Seller",
        name: "Alice Moore",
        text: "Great platform for sellers, very efficient.",
        stars: 5,
      },
    ];
    const visibleReviews = showAll ? reviews : reviews.slice(0, 4);
  return (
    <section className="tf-section tf-about style-2 mt-3">
      <div className="icon">
        <svg
          width="208"
          height="208"
          viewBox="0 0 208 208"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_f_2337_5328)">
            <path
              d="M88.0594 196L88.0594 142.485L50.2119 180.333L27.6674 157.788L65.5149 119.941L12 119.941L12 88.0594L65.5149 88.0594L27.6674 50.2119L50.2119 27.6673L88.0594 65.5148L88.0594 12L119.941 12L119.941 65.5149L157.788 27.6673L180.333 50.2119L142.485 88.0594L196 88.0594L196 119.941L142.485 119.941L180.333 157.788L157.788 180.333L119.941 142.485L119.941 196L88.0594 196Z"
              fill="url(#paint0_linear_2337_5328)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_2337_5328"
              x="0"
              y="0"
              width="208"
              height="208"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="6"
                result="effect1_foregroundBlur_2337_5328"
              />
            </filter>
            <linearGradient
              id="paint0_linear_2337_5328"
              x1="196"
              y1="104"
              x2="12"
              y2="104"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="var(--primary-color35)" />
              <stop
                offset="1"
                stopColor="var(--primary-color35)"
                stopOpacity="0"
              />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="icon-2">
        <svg
          width="302"
          height="302"
          viewBox="0 0 302 302"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_f_2337_5282)">
            <path
              d="M234.678 38.4808L198.329 110.138L274.714 85.1672L289.589 130.668L213.203 155.638L284.86 191.988L263.205 234.677L191.548 198.328L216.518 274.713L171.018 289.588L146.047 213.202L109.698 284.859L67.0084 263.204L103.358 191.547L26.9721 216.517L12.0979 171.017L88.4837 146.046L16.8268 109.697L38.4818 67.0074L110.139 103.357L85.1682 26.9711L130.669 12.0969L155.639 88.4827L191.989 16.8268L234.678 38.4808Z"
              fill="url(#paint0_linear_2337_5282)"
            />
          </g>
          <defs>
            <filter
              id="filter0_f_2337_5282"
              x="0.0976562"
              y="0.0966797"
              width="301.49"
              height="301.491"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="6"
                result="effect1_foregroundBlur_2337_5282"
              />
            </filter>
            <linearGradient
              id="paint0_linear_2337_5282"
              x1="27.6543"
              y1="88.352"
              x2="274.032"
              y2="213.333"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="var(--primary-color35)" />
              <stop
                offset="1"
                stopColor="var(--primary-color35)"
                stopOpacity="0"
              />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="tf-container mt-0">
        <div className="row">
          <div className="col-xl-6 col-lg-5 col-md-12 text-center justify-content-center mb-0 mt-2">
            <div className="text-center tf-heading style-2 wow fadeInUp justify-content-center">
              <h2 className="text-center heading"dir="rtl">
                {t("buyCoins")} <span>{t("eaFC26Coins")}</span> {t("today")}
              </h2>
              <p className="text-center sub-heading" dir="rtl">
                {t("safeCoins")} {t("boostFIFA")} {t("trustedPlayers")}
              </p>
            </div>

            <div className="text-center counter-wrap justify-content-center">
              <div className="text-center tf-counter wow fadeInUp">
                <h6 className="text-center">{t("totalCoinsSold")}</h6>
                <div className="content text-center">
                  <span
                    className="counter-number"
                    data-to="2240"
                    data-speed="2000"
                  >
                    2240M
                  </span>
                  +
                </div>
              </div>
              <div className="text-center tf-counter wow fadeInUp">
                <h6 className="text-center">{t("profilesWhitelisted")}</h6>
                <div className="content text-center">
                  <span
                    className="counter-number"
                    data-to="1000"
                    data-speed="2000"
                  >
                    1000
                  </span>
                  +
                </div>
              </div>
            </div>

            <Button02 title={t("readMore")} path="/about-us" />
          </div>

          <div className="cardo col-xl-6 col-lg-7 col-md-12 mt-2">
            <div className="row">
              {data.map((idx) => (
                <div key={idx.id} className="col-md-6">
                  <div className="tf-step wow fadeInUp" data-wow-delay="0.2s">
                    <div className="step-title">
                      <div className="sub-number">0{idx.id}</div>
                      <h3>{idx.title}</h3>
                    </div>
                    <p>{idx.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>


        <div className="title-ss wow fadeInUp mt-4 ">
          <h3 className=" text-center mt-4 pb-5 mb-4">{t('Reviews')}</h3>
          <div className="row mt-4">
            {visibleReviews.map((review) => (
              <div key={review.id} className="col-md-6 col-sm-6">
                <div className="tf-step style2 wow fadeInUp">
                  <div className="step-title">
                    <div className="sub-number" style={{ fontSize: "40px" }}>
                      {review.role}
                    </div>
                    <div className="d-flex align-items-center">
                    
                      <h3 style={{ fontSize: "16px" }}>{review.name}</h3>
                    </div>
                  </div>
                  <p style={{ fontSize: "14px" }}>{review.text}</p>
                  <div
                    className="stars"
                    style={{ fontSize: "18px", color: "gold" }}
                  >
                    {"★".repeat(review.stars)}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bouton Show More / Show Less */}
          <div className="text-center mt-1">
            <button
              className="btn"
              onClick={() => setShowAll(!showAll)}
              style={{
                backgroundColor: "var(--primary-color5)",
                color: "#0c101c",
                border: "none",
                padding: "10px 20px",
                fontSize: "14px",
              }}
            >
              {showAll ? "Show Less" : "Show More"}
            </button>
             {/* <Button02 title= {showAll ? "Show Less" : "Show More"} onClick={() => setShowAll(!showAll)} /> */}
            
          </div>
        </div>
      </div>
    </section>
  );
}

export default About2;
